import './index.css'

const TodoItem = props => {
  const {todoList, onFilterTodo} = props
  const {id, title} = todoList

  const onDeleteFunction = () => {
    onFilterTodo(id)
  }

  return (
    <li className="lists">
      <div className="lists-tittle-container">
        <p className="para">{title}</p>
        <button type="button" onClick={onDeleteFunction} className="button">
          Delete
        </button>
      </div>
    </li>
  )
}

export default TodoItem
